import { render, staticRenderFns } from "./JourneyPhaseOuttro.vue?vue&type=template&id=80049d8a&scoped=true&"
import script from "./JourneyPhaseOuttro.vue?vue&type=script&lang=js&"
export * from "./JourneyPhaseOuttro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80049d8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
